import * as type from '../types/single-contact-list'

export const retrieveSingleContactListDetails = payload => {
    return{
        type: type.REQUEST_SINGLE_CONTACT_LIST_DETAILS,
        payload: payload
    }
}

export const resetSingleContactListDetails = () => {
    return{
        type: type.RESET_SINGLE_CONTACT_LIST_DETAILS
    }
}

export const retrieveSingleContactListRecords = payload => {
    return{
        type: type.REQUEST_SINGLE_CONTACT_LIST_RECORDS,
        payload: payload
    }
}

export const resetSingleContactListRecords = () => {
    return{
        type: type.RESET_SINGLE_CONTACT_LIST_RECORDS
    }
}


export const changeSingleContactListModal = payload => {
    return{
        type: type.CHANGE_SINGLE_CONTACT_LIST_MODAL,
        modal: payload
    }
}

export const requestAddSingleRecord = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_CONTACT_LIST_RECORD,
        payload: payload
    }
}

export const resetAddSingleRecord = () => {
    return{
        type: type.RESET_ADD_SINGLE_CONTACT_LIST_RECORD
    }
}

export const setActiveContactDisplay = payload => {
    return{
        type: type.SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY,
        details: payload
    }
}

export const resetActiveContactDisplay = () => {
    return{
        type: type.RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY
    }
}

export const setEditContactDisplay = payload => {
    return{
        type: type.SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT,
        details: payload
    }
}

export const resetEditContactDisplay = () => {
    return{
        type: type.RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT
    }
}

export const selectSingleContactDisplay = payload => {
    return{
        type: type.REQUEST_VIEW_CONTACT_SELECTION,
        payload: payload
    }
}

export const resetSingleContactDisplay = () => {
    return{
        type: type.RESET_VIEW_CONTACT_SELECTION
    }
}

export const updateSingleContactDisplay = payload => {
    return{
        type: type.REQUEST_UPDATE_CONTACT_SELECTION,
        payload: payload
    }
}

export const resetUpdateSingleContactDisplay = () => {
    return{
        type: type.RESET_UPDATE_CONTACT_SELECTION
    }
}

export const changeSingleContactVerification = payload => {
    return{
        type: type.REQUEST_CHANGE_SINGLE_CONTACT_VERIFICATION,
        payload: payload
    }
}

export const resetSingleContactVerification = () => {
    return{
        type: type.RESET_CHANGE_SINGLE_CONTACT_VERIFICATION
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_CONTACTS_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_CONTACTS_DELETION_ARRAY,
        id: payload
    }
}


export const requestDeleteContactsArray = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_CONTACT_LIST_ARRAY,
        details: payload
    }
}

export const resetDeleteContactsArray = () => {
    return{
        type: type.RESET_DELETE_SINGLE_CONTACT_LIST_ARRAY
    }
}

export const setActiveContactDeletion = payload => {
    return{
        type: type.SET_ACTIVE_CONTACT_DELETION,
        data: payload
    }
}

export const resetActiveContactDeletion = payload => {
    return{
        type: type.RESET_ACTIVE_CONTACT_DELETION
    }
}

export const requestDeleteSingleContact = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_CONTACT,
        details: payload
    }
}

export const resetDeleteSingleContact = () => {
    return{
        type: type.RESET_DELETE_SINGLE_CONTACT
    }
}

export const appendOverridesArray = payload => {
    return{
        type: type.APPEND_CSV_FIELD_OVERRIDES_ARRAY,
        details: payload
    }
}

export const subtractOverridesArray = payload => {
    return{
        type: type.SUBTRACT_CSV_FIELD_OVERRIDES_ARRAY,
        details: payload
    }
}

export const requestAddCsvRecord = payload => {
    return{
        type: type.REQUEST_UPLOAD_SINGLE_CSV_FILE,
        payload: payload
    }
}

export const resetAddCsvRecord = () => {
    return{
        type: type.RESET_UPLOAD_SINGLE_CSV_FILE
    }
}